import { CarouselResponse } from '@/core/domain/carousel/models/carousel.model';
import { CarouselRepository } from '@/core/domain/carousel/repositories/carousel.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CarouselImplRepository extends CarouselRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getCarouselData(): Observable<CarouselResponse> {
        return this.httpClient
            .get<CarouselResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.carousel,
                ].join('/'),
            )
            .pipe(
                switchMap((carouselResponse: CarouselResponse) => {
                    const carousel: CarouselResponse = {
                        type: carouselResponse.type,
                        action: carouselResponse.action,
                        notifications: carouselResponse.notifications,
                        data: carouselResponse.data,
                    };

                    return of(carousel);
                }),
            );
    }
}
